/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/* eslint-disable @typescript-eslint/no-unsafe-call */
import { useState, useEffect, useRef } from 'react';

import axios, { AxiosResponse } from 'axios';

import { snakeCaseConverter } from '@app/common/helpers/caseConversion';

import { IContactForm } from '../interfaces';

export const sendContactForm = async (data: IContactForm): Promise<AxiosResponse<unknown>> => {
  const formData = new FormData();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const convertedData = snakeCaseConverter(data);

  Object.entries(convertedData).forEach(([key, value]) => {
    if (value !== null && value !== '' && value !== -1 && value !== undefined) {
      formData.append(key, value.toString());
    }
  });

  const response = await axios({
    method: 'post',
    url: '/contact_us',
    data: formData,
  });

  return response;
};

export const useIntersectionObserver = () => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          const isEnteringFromBottom = entry.boundingClientRect.top < window.innerHeight;
          if (entry.isIntersecting && isEnteringFromBottom) {
            setIsIntersecting(true);
          } else if (!entry.isIntersecting && isIntersecting) {
            setIsIntersecting(true);
          } else if (!entry.isIntersecting && !isIntersecting) {
            setIsIntersecting(false);
          }
        },
        {
          root: null,
          threshold: 0.1,
        }
      );

      observer.observe(ref.current);

      return () => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      };
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {};
  }, []);

  return { isIntersecting, ref };
};
